<template>
    <div class="pos_settings">

        <div class="form-group" v-for="(key_val,key_name) in basic_params"
             v-if="key_name.length > 0 && is_text_field(key_name)">

            <label class="form-label">
                {{ __t(key_name.toUpperCase()) }}
            </label>

            <div class="input-group input-group-lg bg-white shadow-inset-2 with_icon">
                <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-left-0 border-right-0 py-1 px-3">
                        <span class="icon-stack fs-xxl">
                            <i class="base-7 icon-stack-3x color-primary-500"></i>
                            <i class="fal fa-database icon-stack-1x text-white"></i>
                        </span>
                    </span>
                </div>

                <b-form-input
                    debounce="300"
                    class="form-control  bg-transparent pl-5"
                    :key="key_name"
                    @update="on_change_value(key_name)"
                    :state=is_valid_key(basic_params[key_name])
                    v-model="basic_params[key_name]"
                    :id="'basic_param_' + key_name"
                >
                </b-form-input>
            </div>
        </div>

        <div class="form-group">
            <label class="form-label">
                {{ __t('POS_FILTER_CATEG') }}
            </label>
            <v-select class="imc_reasons" taggable multiple v-model="categories"/>
        </div>

        <div class="row">
            <div class="col-4 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('send_price')">
                <yes_no
                    key="POS_SEND_ORDER_PRICE"
                    title="POS_SEND_ORDER_PRICE"
                    v-model="basic_params.send_price"
                >
                </yes_no>
            </div>

            <div class="col-4 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('send_full_price')">
                <yes_no
                    key="POS_ORDER_ALWAYS_FULL_PRICE"
                    title="POS_ORDER_ALWAYS_FULL_PRICE"
                    v-model="basic_params.send_full_price">
                </yes_no>
            </div>

            <div class="col-4 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('load_all_organizations')">
                <yes_no
                    key="POS_LOAD_ALL_ORG"
                    title="POS_LOAD_ALL_ORG"
                    v-model="basic_params.load_all_organizations"
                >
                </yes_no>
            </div>
        </div>

        <div class="row"  v-if="basic_params.hasOwnProperty('as_delivery')">
            <div class="col-4 col-lg-4 col-sm-4 col-md-4">
                <yes_no
                    key="POS_SEND_ORDER_AS_DELIVERY"
                    title="POS_SEND_ORDER_AS_DELIVERY"
                    v-model="basic_params.as_delivery">
                </yes_no>
            </div>
        </div>


        <div class=" mt-4">
            <div class="panel-tag mb-1">
                {{__t("SYNC_POS_DATA")}}
            </div>

            <div class="row">
                <div class="col-4 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('sync_stop')">
                    <yes_no
                        key="SYNC_POS_STOP_LIST"
                        title="SYNC_POS_STOP_LIST"
                        v-model="basic_params.sync_stop"
                    >
                    </yes_no>
                </div>

                <div class="col-4 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('sync_order_state')">
                    <yes_no
                        key="SYNC_POS_ORDER_STATE"
                        title="SYNC_POS_ORDER_STATE"
                        v-model="basic_params.sync_order_state"
                    >
                    </yes_no>
                </div>


                <div class="col-4 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('full_sync_modifier')">
                    <yes_no
                        key="FULL_SYNC_MODIFIER"
                        title="FULL_SYNC_MODIFIER"
                        v-model="basic_params.full_sync_modifier"
                    >
                    </yes_no>
                </div>

                <div class="col-4 mt-2 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('push_rest_title_in_comment')">
                    <yes_no
                        key="PUSH_REST_TITLE_COMMENT"
                        title="PUSH_REST_TITLE_COMMENT"
                        v-model="basic_params.push_rest_title_in_comment"
                    >
                    </yes_no>
                </div>


                <div class="col-4 mt-2 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('lock_categories_tree_update')">
                    <yes_no
                        key="LOCK_CATEGORIES_TREE_UPDATE"
                        title="LOCK_CATEGORIES_TREE_UPDATE"
                        v-model="basic_params.lock_categories_tree_update"
                    >
                    </yes_no>
                </div>


                <div class="col-4 mt-2 col-lg-4 col-sm-4 col-md-4" v-if="basic_params.hasOwnProperty('push_stop_by_name')">
                    <yes_no
                        key="PUSH_STOP_BY_NAME"
                        title="PUSH_STOP_BY_NAME"
                        v-model="basic_params.push_stop_by_name"
                    >
                    </yes_no>
                </div>


            </div>
        </div>


    </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import vSelect from 'vue-select';
import yes_no from "../../../sys/radio/yes_no.vue";

const {mapFields} = createHelpers({
    getterType: 'pos/getPosStateField',
    mutationType: 'pos/updatePosStateField',
});

export default {
    name: "pos_basic_settings",
    components: {
        vSelect,
        yes_no
    },
    methods: {
        is_valid_key(key_name) {
            return true;
        },

        is_text_field(key_name) {
            if(this.params_type.hasOwnProperty(key_name)) {
                let cur_type = this.params_type[key_name];
                return cur_type === 'string' && key_name !== 'round_type';
            }

            return !(key_name === 'id');
        },

        on_change_value(key_name) {
            if (this.basic_params.hasOwnProperty(key_name)) {
                this.$emit('on_change', {
                    'key_name': key_name,
                    'key_val': this.basic_params[key_name],
                    'key_type': "basic",
                })
            }
        },
    },

    computed: {

        basic_params() {
            return this.pos_item.basic_params;
        },

        params_type() {
            return this.pos_item.params_type;
        },

        categories: {
            get: function () {
                if (this.basic_params.hasOwnProperty('filter_categories')) {
                    return this.basic_params.filter_categories;
                }
            },
            set: function (val) {
                if (this.basic_params.hasOwnProperty('filter_categories')) {
                    this.basic_params.filter_categories = val;
                    this.on_change_value('filter_categories')
                }
            }
        },

        ...mapFields([
            'pos_item'
        ])
    },
}
</script>

<style scoped>

</style>
